import React from 'react'
import { Box } from '@material-ui/core'
import { useStyles } from './styles'

export const DeviceSectionGroup = ({ children }) => {
    const classes = useStyles()

    return <Box className={classes.deviceSectionContainer}>{children}</Box>
}
